<template>
  <CRow v-if="Authorized">
    <CCol col="12" lg="6">
      <template v-if="userData">
        <b-spinner variant="dark" small v-show="Loading" class="mb-2" />
        <CAlert v-show="SavingFailure && !Loading" color="danger">
          Tallennus epäonnistui. Yritä uudelleen. Mikäli virhe toistuu, ota
          yhteyttä Mielenmestarit -ylläpitoon.
        </CAlert>
        <CAlert v-show="Saved && !Loading" color="success">
          Käyttäjän tiedot tallennettu.
        </CAlert>
        <CCard>
          <CCardBody>
            <template v-if="!AskToConfirm">
              <CRow>
                <CCol sm="12">
                  <CInput
                    label="Nimi"
                    placeholder="Syötä nimi"
                    v-model="userData.Name"
                    :disabled="true"
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12">
                  <CInput
                    label="Sähköposti"
                    placeholder="Syötä sähköpostiosoite"
                    v-model="userData.Email"
                    :disabled="true"
                  />
                  <CAlert v-show="!IsUserMailValid" color="danger">
                    Syötä sähköpostiosoite oikein!
                  </CAlert>
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12">
                  <span class="w-100 float-left mb-2">Aktiivinen</span>
                  <CSwitch
                    label="Status"
                    :color="'success'"
                    variant="3d"
                    @update:checked="UpdateStatus"
                    :checked="userData.Status === 'Active' ? true : false"
                    :disabled="
                      IsThisMe ||
                        Loading ||
                        (ActiveUsers.length >= LicenceAmount &&
                          userData.Status !== 'Active')
                    "
                  />
                </CCol>
              </CRow>
              <CRow>
                <CCol sm="12">
                  <span class="w-100 float-left mb-2">Pääkäyttäjä</span>
                  <CSwitch
                    label="Pääkäyttäjä"
                    :color="'success'"
                    variant="3d"
                    @update:checked="UpdateAdmin"
                    :checked="userData.Admin"
                    :disabled="IsThisMe || Loading"
                  />
                </CCol>
              </CRow>
            </template>
            <template v-if="AskToConfirm">
              <h5>
                Haluatko varmasti poistaa käyttäjän "{{ userData.Name }}"?
              </h5>
              <CAlert v-show="DeleteFailure" color="danger">
                Käyttäjän poistaminen epäonnistui. Yritä uudelleen. Mikäli virhe
                toistuu, ota yhteyttä Mielenmestarit -ylläpitoon.
              </CAlert>
              <hr />
              <div class="justify-content-between d-flex">
                <CButton color="info" @click="AskToConfirm = false" class="mr-2"
                  >En</CButton
                >
                <CButton color="danger" @click="Delete">Kyllä</CButton>
              </div>
            </template>
          </CCardBody>
          <CCardFooter
            v-if="!AskToConfirm"
            class="justify-content-between d-flex"
          >
            <CButton color="primary" @click="goBack">Takaisin</CButton>
            <div role="group">
              <CButton
                color="danger"
                :disabled="IsThisMe"
                @click="AskToConfirmFunc"
                >Poista käyttäjä</CButton
              >
            </div>
          </CCardFooter>
        </CCard>
      </template>
      <template v-else>
        <CAlert v-show="!DeletionInProgress" color="danger">
          Käyttäjää ei löydy
        </CAlert>
      </template>
    </CCol>
  </CRow>
</template>

<script>
import find from "lodash/find";
import api from "@/utils/api";
export default {
  name: "User",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.usersOpened = from.fullPath.includes("kayttajat");
    });
  },
  data() {
    return {
      usersOpened: null,
      AskToConfirm: false,
      DeleteFailure: false,
      DeletionInProgress: false,
      Loading: false,
      SavingFailure: false,
      Saved: false
    };
  },
  computed: {
    Authorized() {
      return this.$store.state.Authorized;
    },
    Role() {
      return find(this.$store.state.Authorization.AdminRoles, {
        NameCleaned: this.$route.params.role
      });
    },
    IsThisMe() {
      return (
        this.userData &&
        this.userData.Email === this.$store.state.Authorization.Email
      );
    },
    userData: {
      get: function() {
        const Id = this.$route.params.Id;
        const user = find(this.$store.state.Users[this.Role.Id], { Id: Id });
        return user !== undefined ? user : null;
      },
      set: function(Value) {
        //console.log(Value)
      }
    },
    IsUserMailValid() {
      return this.ValidateEmail(this.userData.Email);
    },
    TrimmedUserName() {
      return this.userData.Name.trim();
    },
    IsUserNameValid() {
      return "Name" in this.userData === true && this.TrimmedUserName.length > 0
        ? true
        : false;
    },
    IsUserDataValid() {
      return this.IsUserMailValid && this.IsUserNameValid;
    },
    FreeLicenceAmount() {
      return this.LicenceAmount - this.ActiveUsers.length;
    },
    LicenceAmount() {
      return this.$store.state.LicenceAmount;
    },
    AllUsers() {
      return this.$store.state.Users;
    },
    Users() {
      return this.AllUsers && this.Role.Id in this.$store.state.Users === false
        ? []
        : this.$store.state.Users[this.Role.Id];
    },
    ActiveUsers() {
      return this.Users.filter(User => User.Status === "Active");
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    UpdateStatus: function(Status) {
      this.userData.Status = Status ? "Active" : "InActive";
      this.SaveUser();
    },
    UpdateAdmin: function(Value) {
      this.userData.Admin = Value;
      this.SaveUser();
    },
    ValidateEmail(mail) {
      return this.$ValidateEmail(mail);
    },
    SaveUser: async function() {
      if (this.userData) {
        this.Loading = true;
        let Saving = await api.post(
          process.env.VUE_APP_UPSEERIKERHO_API_URL + "/user",
          {
            user_email: this.userData.Email,
            Status: this.userData.Status,
            edit_user: true,
            role: this.Role.Id,
            Admin: this.userData.Admin ? "yes" : "no"
          }
        );
        this.Loading = false;
        if (Saving !== "success") {
          this.SavingFailure = true;
          return;
        }
        this.SavingFailure = false;
        this.Saved = true;
      }
    },
    Delete: async function() {
      if (this.IsThisMe) {
        return;
      }
      this.DeletionInProgress = true;
      let DeletionStatus = await api.delete(
        process.env.VUE_APP_UPSEERIKERHO_API_URL + "/user",
        {
          user_email: this.userData.Email
        }
      );
      if (DeletionStatus === true) {
        this.$router.go(-1);
        this.$store.commit("UpdateUserList", {
          Role: this.Role.Id,
          User: {
            Id: this.userData.Id
          },
          DeleteUser: true
        });
        return;
      }
      this.DeleteFailure = true;
      this.DeletionInProgress = false;
    },
    AskToConfirmFunc() {
      this.AskToConfirm = true;
    }
  }
};
</script>
